import React from 'react';
import { useNavigate } from 'react-router-dom';

const TicketBooking = () => {
  const navigate = useNavigate();

  return (
    <>
      <div style={{
        background: 'linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%)', // New purple-pink gradient
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#333', // Darker text for contrast
        fontFamily: 'Inter, sans-serif',
        textAlign: 'center',
        padding: '30px',
      }}>
        <div style={{
          background: 'rgba(255,255,255,0.98)', // Whiter background
          padding: '50px', // Increased padding
          borderRadius: '15px', // More rounded
          boxShadow: '0 10px 30px rgba(0,0,0,0.15)', // Enhanced shadow
          color: '#673ab7', // Deeper purple for text
          maxWidth: '650px', // Wider card
          width: '100%',
          marginBottom: '30px', // More space for buttons
        }}>
          <h2 style={{ marginBottom: '25px', fontSize: '2.8rem', fontWeight: '700' }}>Ticket Booking</h2> {/* Larger, bolder heading */}
          <p style={{ fontSize: '1.3rem', lineHeight: '1.6' }}>This page is under construction. We're working hard to bring you exciting features soon!</p> {/* Larger text */}
          <span style={{ fontSize: '5rem', display: 'block', margin: '20px 0' }}>🎟️</span> {/* Larger icon */}
        </div>

        {/* Navigation Buttons */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '18px', width: '100%', maxWidth: '350px' }}> {/* Increased gap and max-width */}
          <button
            onClick={() => navigate('/utility-dashboard')}
            style={{
              padding: '15px 25px', // Larger button
              backgroundColor: '#9c27b0', // Purple color
              color: 'white',
              border: 'none',
              borderRadius: '10px', // More rounded
              fontSize: '1.1rem', // Larger font
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.3s ease-in-out',
              boxShadow: '0 4px 10px rgba(0,0,0,0.1)', // Subtle shadow
            }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#7b1fa2'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#9c27b0'}
          >
            Back to Utilities
          </button>
        </div>
      </div>
    </>
  );
};

export default TicketBooking;